'use strict';
const giftCardHelpers = require('../helper/giftCardHelper');
const loyaltyHelpers = require('../checkout/loyalty');
const basketHelper = require('../helper/basketHelper');

/**
 * Displays an error modal with the given content.
 * @param {string} content The content to display in the modal.
 */
function errorModal(content) {
    const errorModalDetails = window.resources.errorModalDetails || {};
    const errorModalTitle = errorModalDetails.title || 'ERROR';
    const errorModalButtonText = errorModalDetails.buttonText || 'OK';

    $.modal({
        title: errorModalTitle,
        content: content,
        customClasses: 'modal--error',
        buttons: [
            `<button class="btn btn-primary px-0" data-dismiss="modal">${errorModalButtonText}</button>`
        ]
    });
}

// GIFT CARD : Module contains all the functions for Gift card.
const giftCard = () => {
    /**
     * Add method is used to apply a gift card, method invoked on click of apply button.
     * once a card is successfully applied, refresh the Order total.
     * @param {string} giftCardId GiftCertificated ID
     * @param {string} giftCardPin Gift Certificate Pin
     * @param {string} csrfToken - csrfToken to use in request
     * @param {string} addGCUrl DW service url to add the gift card
     */
    const addGiftCard = (giftCardId, giftCardPin, csrfToken, addGCUrl) => {
        $.spinner().start();
        $.ajax({
            url: addGCUrl,
            type: 'POST',
            data: {
                giftCertID: giftCardId,
                giftCertPin: giftCardPin,
                csrf_token: csrfToken
            }
        })
            .always(() => {
                $.spinner().stop();
            })
            .done((data) => {
                if (data.error) {
                    errorModal(data.errorMessage);
                    return;
                }

                if (data.giftCard) {
                    if (data.giftCard.valid) {
                    // clear the form so another gift card can be entered
                        $('#gift-refund-code, #gift-refund-pin').val('').trigger('change')
                            .closest('.form-group')
                            .removeClass('focus-fill');
                        // remove invalid error
                        $('#gift-refund-code').removeClass('is-invalid')
                            .closest('.form-group')
                            .removeClass('is-invalid');
                        // display a success banner
                        $.alert({
                            content: data.giftCard.successMsg,
                            placement: 'banner',
                            theme: 'success'
                        });
                        if (data.giftCard.isFullCovered) {
                            giftCardHelpers.updateCreditCardFields(false);
                            $('#selectedPaymentOption').val('GIFT_CERTIFICATE');
                            $('.billing-payment-options-block').data('fully-covered', data.giftCard.isFullCovered);

                            const $rewardsBannerRedemption = $('.rewards-balance-redemption-banner');
                            if ($rewardsBannerRedemption.length && data.basket.paymentInstrumentsDetails && data.basket.paymentInstrumentsDetails.loyaltyRewardsDetails && !data.basket.paymentInstrumentsDetails.loyaltyRewardsDetails.isLoyaltyRewardsApplied) {
                                $('.js-apply-loyalty-rewards').hide();
                            }
                        }
                    } else {
                        $('#gift-refund-code').addClass('is-invalid').closest('.form-group').addClass('is-invalid');
                        $('.csc-checkout-gift-card-error').text(data.giftCard.status.message).show()
                            .closest('.form-group')
                            .addClass('has-danger');
                    }
                }

                if (data.basket) {
                    giftCardHelpers.updateGiftCardlist(data.basket);
                    giftCardHelpers.updatePaymentsection(data.basket);
                    giftCardHelpers.updateOrderSummary(data.basket.totals);
                    loyaltyHelpers.updateForecastedRewards(data.basket.rewards);
                }

                if (data.rewardsCard) {
                    basketHelper.updateRewardsCardAndBanner(data);
                }
            });
    };

    /**
     * removeGiftCard method is used to remove an applied gift card, method is invoked on click of remove button in billing section.
     * once removed, the Order total needs to be refreshed.
     * @param {string} uuid Transaction id for the Gift Card
     * @param {string} removeGCUrl DW service url to remove the gift card
     */
    const removeGiftCard = (uuid, removeGCUrl) => {
        $.ajax({
            url: removeGCUrl,
            type: 'POST',
            data: {
                uuid: uuid
            }
        })
            .done((data) => {
                if (data.giftCard && data.giftCard.valid && data.basket) {
                    giftCardHelpers.updateGiftCardlist(data.basket);
                    giftCardHelpers.updatePaymentsection(data.basket);
                    giftCardHelpers.updateOrderSummary(data.basket.totals);
                    loyaltyHelpers.updateForecastedRewards(data.basket.rewards);
                    $('.billing-payment-options-block').data('fully-covered', false);
                }

                if (data.rewardsCard) {
                    basketHelper.updateRewardsCardAndBanner(data);
                }
            });
    };


    // Public API
    return {
        addGiftCard: addGiftCard,
        removeGiftCard: removeGiftCard
    };
};


/* ########## INITIALIZATION ########## */
(() => {
    /**
     * event triggered on click of apply button in checkout-payment stage.
     * Gift card ID and pin sent to server. on successful validation it's added to cart.
     */
    $(document).on('click', '.btn-apply-gift-refund', function () {
        const $giftCardId = $('#gift-refund-code');
        const csrfToken = $('.js-gc-csrf').val();
        const $giftCardPin = $('#gift-refund-pin');
        const giftCardIdVal = $giftCardId.val().trim();
        const giftCardPinVal = $giftCardPin.val();
        let hasError = false;

        // clear error states
        $('.csc-checkout-gift-card-error').text('').hide()
            .closest('.form-group')
            .removeClass('has-danger');
        $giftCardId.parent().find('.invalid-feedback').text('').hide();
        $giftCardPin.parent().find('.invalid-feedback').text('').hide();

        $giftCardId.val(giftCardIdVal);
        if (!giftCardIdVal) {
            $giftCardId.parent().find('.invalid-feedback').text($giftCardId.data('missing-error')).show();
            $giftCardId.addClass('is-invalid').closest('.form-group').addClass('is-invalid');
            hasError = true;
        } else if (/\D/.test(giftCardIdVal)) {
            $giftCardId.parent().find('.invalid-feedback').text($giftCardId.data('parse-error')).show();
            $giftCardId.addClass('is-invalid').closest('.form-group').addClass('is-invalid');
            hasError = true;
        }

        if (!giftCardPinVal) {
            $giftCardPin.parent().find('.invalid-feedback').text($giftCardPin.data('missing-error')).show();
            hasError = true;
        } else if (/\D/.test(giftCardPinVal)) {
            $giftCardPin.parent().find('.invalid-feedback').text($giftCardPin.data('parse-error')).show();
            hasError = true;
        }

        if (!hasError) {
            const addGCUrl = $(this).data('action');
            giftCard().addGiftCard(giftCardIdVal, giftCardPinVal, csrfToken, addGCUrl);
        }
    });

    /**
    * event triggered on click of remove button in checkout-payment stage.
    * if the transaction ID is valid, corresponding Gift card is removed from cart and amount is reclaimed.
    */
    $(document).on('click', '.btn-remove-gift-refund', function () {
        const $removeBtn = $(this);
        giftCard().removeGiftCard($removeBtn.data('uuid'), $removeBtn.data('action'));
    });

    /**
     * On load hide the gift card table in checkout page.
     */
    $('.js-gift-card-list').hide();
    $('.row-amount-due').hide();

    $('#gift-refund-code, #gift-refund-pin').stripInvalidChars(/\D/g);
})();

module.exports = giftCard;
